var Js = (function () {
  const changeLayoutFooter = () => {
    let footer = document.getElementsByClassName('footer');

    if (
      document.body.style.marginLeft === '0px' ||
      document.body.style.marginRight === '0px'
    ) {
      footer[0].classList.add('mx-0');
    } else {
      footer[0].classList.remove('mx-0');
    }
  };

  return {
    ChangeLayoutFooter: () => changeLayoutFooter(),
  };
})();
